(function (global) {
    var $ = global.jQuery;

    var setValue = function ($input, value, historyOnly) {
        $input.data("precision-latest-valid", value);
        if (historyOnly)
            return;
        $input.val(value);
    };
    var rollback = function ($input) {
        $input.val($input.data("precision-latest-valid") || "");
    };
    var trigger = function ($input, when) {
        if (when === "valid")
            $input.trigger("input", {from: "input.precision"});
    };

    document.body.addEventListener("input", function (event) {
        var $input = $(event.target);
        if (!$input.hasClass("precision"))
            return;
        var precision = $input.data("precision");
        if (precision == null)
            return;

        var whenPropagation = $input.data("whenpropagation");
        whenPropagation = whenPropagation || "valid";
        event.stopPropagation();
        event.stopImmediatePropagation();

        var isPositiveOnly = $input.data("positiveonly");
        isPositiveOnly = isPositiveOnly != null && isPositiveOnly !== "false";

        var value = $input.val();
        var rawValue = value;
        var dotIndex = value.indexOf(".");
        var minusIndex = value.lastIndexOf("-");

        if (isPositiveOnly && minusIndex !== -1) {
            rollback($input);
            trigger($input, whenPropagation);
            return;
        }

        if (
            (minusIndex === 0 && value.length === 1) ||
            (dotIndex === value.length - 1 && dotIndex === value.lastIndexOf(".") && value !== "-.")
        ) {
            setValue($input, value, true);
            trigger($input, whenPropagation);
            return;
        }

        var currentPrecision = dotIndex === -1 ? 0 : value.length - dotIndex - 1;
        value = _.toNumber(value);
        if (!isFinite(value)) {
            rollback($input);
            trigger($input, whenPropagation);
            return;
        }

        value = _[value < 0 ? "ceil" : "floor"](value, precision);
        if (currentPrecision > 0)//当前有小数时
            value = value.toFixed(Math.min(currentPrecision, precision));//保证输入过程中的x.0状态
        if (currentPrecision > precision)//当特殊情况(1.000000000000001e100等)在删减时产生的小数大于允许精度时，尝试收回到常规数值（过滤掉1.000场景）
            value = _.toFinite(value);
        setValue($input, value, value.toString() === rawValue);//在转换后数值和输入内容一致时不更新输入框，减少移动光标
        trigger($input, whenPropagation);
    }, {capture: true});
})(window);